import manualImportPage from './view/contractInvoiceEdit.html'
import importmodal from '../../inputInvoice/collection/view/importmodal.html'

class contractManageEditCtrl {
    constructor(
        $scope, httpRequest, $state, logger, sweetalert, $stateParams,
        Upload, $timeout, $uibModal, scanService, $rootScope,
    ) {
        $scope.contractManageObj = $stateParams
        httpRequest.get_dictByTypeArr(['ivat_invoice_status', 'ivat_inv_type']).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        function initContractManage() {
            httpRequest.get_getContractDetail($scope.contractManageObj.contractId).then((res) => {
                $scope.contractInfo = res.data.value
                let dynamicKeyValueList = res.data.value.dynamicKeyValue ? JSON.parse(res.data.value.dynamicKeyValue) : []
                // 页面固定字段
                const hardCodedFields = [
                    '单据编号',
                    '合同类型',
                    '合同张数',
                    '扫描点',
                    '票据张数',
                    '扫描人',
                    '票据金额',
                    '扫描时间',
                ]
                // arr 是否包含 value
                function contains(arr, value) {
                    return arr.filter((item) => (item === value)).length > 0
                }
                // dynamicKeyValueList = dynamicKeyValueList.filter(valueItem => (valueItem.qryPageName !== '单据编号'))
                // 动态字段和固定字段去重
                dynamicKeyValueList = dynamicKeyValueList.filter((valueItem) => (
                    !contains(hardCodedFields, valueItem.qryPageName)
                ))
                $scope.dynamicKeyValueList = dynamicKeyValueList
            })
        }
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    // 校对通过的跳转到发票管理详情可获取到全票面信息
                    // 校对未通过跳转到发票收集详情
                    const subUrl = item.archiveStatus === '1' ? 'invoiceDetail' : 'invoice'
                    const url = $state.href(
                        `${$state.$current.name}.${subUrl}`,
                        {
                            object: JSON.stringify({
                                invoiceCode: item.invoiceCode,
                                invoiceNumber: item.invoiceNumber,
                            }),
                        }, { reload: true },
                    )
                    window.open(url, '_blank')
                },
            }, {
                label: '编辑',
                showWhile(item) {
                    return $scope.contractManageObj.mode === 'edit' && item.verifyStatus !== '1'
                },
                handler(item) {
                    $scope.editInvoice(item)
                },
            }, {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确定删除这张发票信息？').then(() => {
                        httpRequest.get_deleteInvoice({
                            params: {
                                invoiceId: item.invoiceId,
                                contractId: $scope.contractInfo.contractId,
                            },
                        }).then(() => {
                            logger.logSuccess('删除成功')
                            initContractManage()
                        })
                    })
                },
                showWhile() {
                    return $scope.contractManageObj.mode === 'edit'
                },
            },
        ]
        initContractManage()
        // 查看合同影像
        $scope.viewContractFile = function viewContractFile(v) {
            if (v === 1 && $scope.contractInfo.isSaveContract !== '1') {
                logger.logError('合同影像已被删除，如需查看，请在模版设置中设置')
            } else {
                $state.go(`${$state.current.name}.image`, {
                    contractId: $scope.contractInfo.contractId,
                    tabIndex: v,
                    readonly: 'readonly',
                })
            }
        }
        /**
         * 显示扫描补录结果
         */
        function showScanProgress() {
            const modalInstance = $uibModal.open({
                template: importmodal,
                controller: 'scanModalCtrl',
                animation: true,
                openedClass: 'mod-modal mod-modal-lg',
            })
            modalInstance.result.then(() => {
                $timeout.cancel($rootScope.scanTimeout)
                initContractManage()
            }, () => {
                $timeout.cancel($rootScope.scanTimeout)
                initContractManage()
            })
            return modalInstance
        }
        // 扫描补录
        $scope.scanInvoice = function scanInvoice() {
            scanService.supplement({
                scanType: '4',
                scanSource: '2',
                sourceIdentity: $scope.contractInfo.contractId, // 合同模板的业务名称
                imgType: '0',
                dataSource: '2',
            }).then(() => {}, (error) => {
                if (error) {
                    logger.logError(error)
                }
                $timeout.cancel($rootScope.scanTimeout)
            })
            showScanProgress()
        }
        /**
         * 手工录入或者编辑发票
         * @param  {[type]} invoice [description]
         * @return {[type]}         [description]
         */
        $scope.editInvoice = function editInvoice(invoice = {}) {
            if (invoice.imageKey) {
                return $state.go('input.electronImage.contractManagement.edit.editinvoice', {
                    contractId: $scope.contractInfo.contractId,
                    tabIndex: 2,
                    invoiceId: invoice.invoiceId,
                    mode: 'edit',
                })
            }
            return $uibModal.open({
                template: manualImportPage,
                controller: 'contractInvoiceEditCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    contractInvoice() {
                        return {
                            contractId: $scope.contractInfo.contractId,
                            ...invoice,
                        }
                    },
                },
            }).result.then(() => {
                initContractManage()
            }, () => {
                initContractManage()
            })
        }
        /**
         * 显示导入上传结果
         * @param  {object} prams [成功失败数据]
         */
        $scope.openUploadResult = function openUploadResult(prams) {
            const modalInstance = $uibModal.open({
                template: importmodal,
                controller: 'importModalCtrl',
                animation: true,
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return prams
                    },
                },
            })
            modalInstance.result.then(() => {
                initContractManage()
            })
        }

        $scope.uploadFiles = function uploadFiles(file, errFiles) {
            // 不符合文件格式的错误提示
            if (file == null && errFiles.length >= 1) {
                logger.logError('文件类型错误，文件大小不超过50M')
                return
            }
            if (file) {
                file.upload = Upload.upload({
                    url: `${host.etcloudIvatAppZuul}manage/scanInvoice/uploadPdf`,
                    data: {
                        file,
                        fileName: encodeURI(file.name),
                        sourceIdentity: $scope.contractInfo.contractId,
                        source: '3',
                        dataSource: '2',
                    },
                })
                // 文件上传
                // loading动画
                const importinglayer = window.layer.msg('玩命上传中，请耐心等待', {
                    time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                })
                file.upload.then((res) => {
                    $timeout(() => {
                        // 关闭loading
                        window.layer.close(importinglayer)
                        if (!res.data.success) {
                            return logger.logError(res.data.message || '上传失败')
                        }
                        file.result = res.data
                        res.data.value.title = `本次共成功上传${res.data.value.sucessCount ? res.data.value.sucessCount : 0}张发票，${(res.data.value.inputCount ? res.data.value.inputCount : 0) - (res.data.value.sucessCount ? res.data.value.sucessCount : 0)}张失败`
                        res.data.value.type = '导入结果'
                        return $scope.openUploadResult(res.data.value)
                    })
                }, (response) => {
                    if (response.status > 0) {
                        // 关闭loading
                        window.layer.close(importinglayer)
                        logger.logError('上传失败 ')
                    }
                }, (evt) => {
                    file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total, 10))
                })
            }
        }
    }
}

contractManageEditCtrl.$inject = ['$scope', 'httpRequest', '$state', 'logger', 'sweetalert', '$stateParams', 'Upload', '$timeout', '$uibModal', 'scanService', '$rootScope']

export default contractManageEditCtrl



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractManagement/contractManageEditCtrl.js